<template>
  <div class="custom-upload">
    <template v-if="this.value">
      <div class="media-box">
        <img
          :src="require('@/assets/images/close.png')"
          class="close-img"
          @click="$emit('input')"
        />
        <video v-if="showVideo" controls :src="value"></video>
        <el-image v-if="showImage" :src="value" :preview-src-list="[value]" />
      </div>
    </template>
    <Upload
      v-else
      multiple
      type="drag"
      :disabled="disabled"
      :show-upload-list="false"
      :accept="accept"
      :name="this.name"
      :action="actionUrl"
      :max-size="_maxSize"
      :before-upload="beforeUpload"
      :on-exceeded-size="onExceededSize"
      :on-format-error="onFormatError"
      :on-error="onError"
      :on-success="onSuccess"
      :class="className"
    >
      <div class="pla">
        <img
          :src="require(`@/assets/images/upload${!!title ? '1' : ''}.png`)"
          :style="
            title
              ? { width: '178px', height: '125px' }
              : { width: '207px', height: '146px' }
          "
        />
        <div v-if="title" class="title">{{ title }}</div>
        <div class="tip" :class="{ 'no-margin-top': !!title }">
          {{ $t('点击或将文件拖拽到此区域') }}
        </div>
      </div>
    </Upload>
  </div>
</template>
<script>
export default {
  name: 'CustomUpload',
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: 'imgs'
    },
    maxSize: {
      type: Number,
      default: 0
    },
    title: String,
    className: String
  },
  data() {
    return {
      disabled: false,
      loadingInstance: null
    }
  },
  computed: {
    showVideo() {
      return this.name === 'video'
    },
    showImage() {
      return this.name === 'imgs'
    },
    actionUrl() {
      return (
        process.env.VUE_APP_BASE_API +
        {
          imgs: '/oss/uploadImg',
          video: '/oss/uploadVideo'
        }[this.name]
      )
    },
    accept() {
      return {
        imgs: 'image/jgp,image/png,image/jpeg',
        video: 'video/*'
      }[this.name]
    },
    _maxSize() {
      if (this.maxSize) return this.maxSize
      if (this.name === 'imgs') return 8 * 1024
      return 100 * 1024
    }
  },
  methods: {
    closeLoading() {
      if (this.loadingInstance) {
        this.disabled = false
        this.loadingInstance.close()
        this.loadingInstance = null
      }
    },
    beforeUpload() {
      this.disabled = true
      this.loadingInstance = this.$loading({
        target: '.' + this.className || 'ivu-upload',
        duration: 0
      })
    },
    onExceededSize() {
      this.$Message.error(this.$t('文件大小超出限制'))
      this.closeLoading()
    },
    onFormatError() {
      this.$Message.error(this.$t('文件格式错误'))
      this.closeLoading()
    },
    onError() {
      this.$Message.error(this.$t('文件上传失败'))
      this.closeLoading()
    },
    onSuccess({ data }) {
      this.closeLoading()
      this.$emit('input', data[0])
    }
  }
}
</script>
<style scoped lang="less">
.custom-upload {
  width: 348px;
  height: 217px;
  .media-box {
    position: relative;
    width: 100%;
    height: 100%;
    .close-img {
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 100;
      height: 16px;
      width: 16px;
      cursor: pointer;
    }
    video,
    .el-image {
      width: 100%;
      height: 100%;
    }
  }
  .pla {
    padding: 20px 70px;
    .tip {
      margin-top: 16px;
      font-size: 12px;
      font-weight: 400;
      color: #a2a2a2;
      &.no-margin-top {
        margin-top: 0;
      }
    }
    .title {
      font-size: 14px;
      font-weight: 500;
      color: #3890f9;
      line-height: 22px;
      margin-top: 8px;
      margin-bottom: 4px;
    }
  }
}
</style>
